module.exports = __webpack_public_path__ + "static/media/stockhausen_polymorph_4.c5ec6fbb.jpg";